module.exports = __webpack_public_path__ + "static/ffuncars-finance-40d7faf4eae5b5a02f791c4a9b6e22de.webp";